<template>
  <div>
    <div v-if="inactivityTime >= 60" class="screensaver" style="height: 100vh">
      <bibliomap-temp />
    </div>
    <div v-else>
      <v-btn
        @click="backHome"
        v-if="this.selected.subcategories"
        large
        fixed
        class="ma-5 pa-4 home-button"
        color="#f1dd38"
      >
        <v-icon large color="grey darken-3">home</v-icon>
      </v-btn>
      <div
        style="height: 40px; position: fixed"
        v-if="!this.selected.locations || !selected.locations"
      >
        <img
          height="80"
          src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
          class="ma-4"
        />
      </div>
      <v-container v-if="!this.selected.locations" grid-list-md text-xs-center>
        <v-layout row wrap v-if="!selected.subcategories">
          <v-flex xs12>
            <div class="display-3 text-uppercase mt-5">
              Bienvenue à la bibliothèque
            </div>
            <div class="display-1 text-uppercase mt-5">
              Appuyez sur une thématique
            </div>
          </v-flex>
          <v-flex
            :class="
              category.slug === 'hors-collection' ? 'mt-4 xs6' : 'mt-4 xs3'
            "
            v-for="category in categories"
            :key="category.slug"
          >
            <v-card
              class="ma-2 px-3 py-5"
              :color="
                category.slug === 'hors-collection' ? '#e9e0d2' : '#f1dd38'
              "
              @click.native="selectCategory(category)"
            >
              <v-card-text class="px-0 headline">{{
                category.name
              }}</v-card-text>
            </v-card>
          </v-flex>
          <v-flex class="mt-4 xs12">
            <v-card
              class="ma-2 px-3 py-5"
              color="#e9e0d2"
              @click.native="
                selectCategory({ slug: 'all', name: 'Toutes les thématiques' })
              "
            >
              <v-card-text class="px-0 headline"
                >Toutes les thématiques</v-card-text
              >
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else-if="!selected.locations" style="margin-top: 100px">
          <v-flex xs12>
            <v-card class="ma-1 py-4" color="#e9e0d2">
              <v-card-text class="display-1">{{
                selected.category.name
              }}</v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            v-for="subcategory in selected.subcategories"
            :key="subcategory.slug"
            :class="
              selected.category.slug === 'hors-collection' ? 'xs12' : 'xs3'
            "
          >
            <v-card
              class="ma-1 pa-3"
              :color="
                subcategory.categories === 'hors-collection'
                  ? '#f1f0ea'
                  : '#f1dd38'
              "
              @click.native="selectSubcategory(subcategory)"
            >
              <v-card-text class="px-0 body-2">{{
                subcategory.name
              }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <div v-else style="height: 100vh">
        <v-card
          class="card-legend text-xs-center title"
          :color="
            selected.subcategory.categories === 'hors-collection'
              ? '#f1f0ea'
              : '#f1dd38'
          "
        >
          <v-card-text>{{ selected.subcategory.name }}</v-card-text>
        </v-card>
        <MglMap v-bind="mapbox" @load="onMapLoaded">
          <MglGeojsonLayer
            v-if="selected.locations"
            sourceId="locations"
            :source="selected.locations"
            layerId="locations"
            :layer="selected.layer"
          />
          <MglMarker :coordinates="mapbox.currentPosition">
            <img
              src="@/assets/current.png"
              height="30px"
              width="30px"
              slot="marker"
            />
          </MglMarker>
        </MglMap>
      </div>
    </div>
  </div>
</template>

<script>
import { MglMap, MglGeojsonLayer, MglMarker } from "vue-mapbox";
import featurecollection from "../data/subcategories.json";
import { uniqBy } from "lodash";
import moment from "moment";
import BibliomapTemp from '@/components/BibliomapTemp.vue';

export default {
  created() {
    window.addEventListener("scroll", this.updateLastActivity);
    window.addEventListener("touchend", this.updateLastActivity);
  },
  mounted() {
    this.timeInterval = setInterval(this.time, 1000);
    this.messageInterval = setInterval(this.messageChange, 30000);
    moment.locale("fr");
  },
  beforeDestroy() {
    clearTimeout(this.mapTimeout);
    clearInterval(this.messageInterval);
    clearInterval(this.timeInterval);
  },
  destroyed() {
    window.removeEventListener("scroll", this.updateLastActivity);
    window.removeEventListener("touchend", this.updateLastActivity);
  },
  data: () => ({
    categories: [
      {
        name: "COMEM",
        slug: "comem"
      },
      {
        name: "EC+G",
        slug: "ec-g"
      },
      {
        name: "HEG",
        slug: "heg"
      },
      {
        name: "TIC",
        slug: "tic"
      },
      {
        name: "TIN",
        slug: "tin"
      },
      {
        name: "Langues + littérature",
        slug: "langues-litterature"
      },
      {
        name: "Hors collection",
        slug: "hors-collection"
      }
    ],
    featurecollection,
    selected: {
      category: null,
      subcategory: null,
      subcategories: null,
      locations: null,
      layer: {
        id: "locations",
        type: "fill",
        layout: {},
        paint: {
          "fill-color": "#ff0000",
          "fill-opacity": 0.5
        }
      }
    },
    mapbox: {
      accessToken:
        "pk.eyJ1IjoiY2xpZW5nbWUiLCJhIjoiQUo3bUZNcyJ9.HxI36n5gzhdYhxqMG3Zl5g",
      mapStyle: "mapbox://styles/cliengme/cjdbsarr5c1q02so2v0uzzt9k",
      center: [6.659946805822158, 46.779171110047443],
      zoom: 14,
      bearing: 0,
      currentPosition: [6.659908587915527, 46.77921558606112],
      interactive: false,
      attributionControl: false
    },
    lastActivityTime: moment().unix(),
    dateNow: null,
    message: true,
    mapTimeout: null,
    timeInterval: null,
    messageInterval: null,
    isFirstSearch: true
  }),
  components: {
    MglMap,
    MglGeojsonLayer,
    MglMarker,
    BibliomapTemp
  },
  methods: {
    selectCategory: function(selectedCategory) {
      this.selected.category = selectedCategory;
      const filter =
        selectedCategory.slug !== "all"
          ? feature =>
              feature.properties.categories
                .split(",")
                .indexOf(selectedCategory.slug) > -1
          : () => ({});
      this.selected.subcategories = uniqBy(
        this.featurecollection.features
          .filter(filter)
          .map(feature => ({
            slug: feature.properties.slug,
            name: feature.properties.name,
            categories: feature.properties.categories
          }))
          .sort((a, b) => a.name.localeCompare(b.name)),
        "slug"
      );
    },
    selectSubcategory: function(selectedSubcategory) {
      this.selected.locations = Object.assign({}, this.featurecollection);
      this.selected.subcategory = selectedSubcategory;
      this.selected.locations.features = this.featurecollection.features.filter(
        feature => feature.properties.slug === selectedSubcategory.slug
      );
      this.mapTimeout = setTimeout(() => {
        this.selected.subcategories = null;
        this.selected.locations = null;
        this.mapbox.bearing = 141.3;
        this.mapbox.zoom = 21;
        this.isFirstSearch = false;
      }, 30000);
    },
    onMapLoaded: function(event) {
      this.map = event.map;
      this.map.addSource("locations", {
        type: "geojson",
        data: this.selected.locations
      });

      if (this.isFirstSearch && this.map.areTilesLoaded()) {
        this.map.flyTo({ zoom: 21 });
        this.map.on("zoomend", () => {
          this.map.rotateTo(this.map.getBearing() + 141.3);
        });
      }
    },
    backHome: function() {
      if (this.selected.locations) {
        this.mapbox.bearing = 141.3;
        this.mapbox.zoom = 21;
        this.isFirstSearch = false;
      }
      this.selected.subcategories = null;
      this.selected.locations = null;
      clearTimeout(this.mapTimeout);
    },
    updateLastActivity: function() {
      this.lastActivityTime = moment().unix();
    },
    time: function() {
      this.dateNow = moment().unix();
    },
    messageChange: function() {
      this.message = !this.message;
    }
  },
  watch: {
    inactivityTime: function(value) {
      if (value >= 60) {
        this.isFirstSearch = true;
        this.mapbox.zoom = 14;
        this.mapbox.bearing = 0;
      }
    }
  },
  computed: {
    inactivityTime: function() {
      return Math.floor(this.dateNow - this.lastActivityTime);
    },
    formattedDate: function() {
      const formattedDate = moment
        .unix(this.dateNow)
        .format("dddd D MMMM YYYY");
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    },
    formattedTime: function() {
      return moment.unix(this.dateNow).format("HH:mm:ss");
    }
  }
};
</script>

<style>
.application {
  background: #5b686d !important;
  color: #f1f0ea !important;
}
.v-sheet {
  color: #424242 !important;
}

::-webkit-scrollbar {
  display: none;
}
@-webkit-keyframes AnimationName {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@-moz-keyframes AnimationName {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes AnimationName {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.screensaver {
  background: linear-gradient(270deg, #f1dd38, #5b686d);
  background-size: 400% 400%;

  -webkit-animation: AnimationName 30s ease infinite;
  -moz-animation: AnimationName 30s ease infinite;
  animation: AnimationName 30s ease infinite;
}
.card-legend {
  position: fixed !important;
  width: 100vw;
  z-index: 1;
}

.home-button {
  right: 0;
  top: 82vh;
  z-index: 1;
  height: 100px !important;
  width: 100px;
}
</style>